"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isArray.js
// module id = 25
// module chunks = 0 1